import { create } from "zustand";

interface DialogState {
  isOpen: boolean;
  title: string;
  description: string;
  onConfirm: () => void;
  openDialog: (params: {
    title: string;
    description: string;
    onConfirm: () => void;
  }) => void;
  closeDialog: () => void;
}

export const useConfirmDialogStore = create<DialogState>((set) => ({
  isOpen: false,
  title: "",
  description: "",
  onConfirm: () => {},
  openDialog: ({ title, description, onConfirm }) =>
    set({
      isOpen: true,
      title,
      description,
      onConfirm,
    }),
  closeDialog: () =>
    set({
      isOpen: false,
      title: "",
      description: "",
      onConfirm: () => {},
    }),
}));
